
export const getLogs = (state: any) => state.console.logs;